// extracted by mini-css-extract-plugin
module.exports = {"navigationItem":"navigation-item-module__navigationItem___36sAJ"};